export default "__VITE_ASSET__CbwkhjYn__"